import {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client';

export const WebflowWithPledge = () => {
  const [plgElem, setPlgElem] = useState(null);
  const [targetElem, setTargetElem] = useState(null);

  const onMessage = (e) => {
    if (!e.origin.includes('pledge.to')) return;
    try {
      const {data} = e;
      const objMessage = JSON.parse(data);
      switch (objMessage.message) {
        case 'setWidgetHeight':
          break;
        case 'intersectionLoaded':
          break;
        default:
          console.log('Pledge unhandled message: ', objMessage.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    const pledgelingHost = new URL(`https://www.pledge.to/assets/widget.js`);
    if (window.location.host !== 'www.evite.com') {
      pledgelingHost.host = 'evite-test.pledge.to';
    }

    script.src = pledgelingHost.toString();
    script.id = 'plg-widget';
    script.async = true;
    document.body.appendChild(script);

    window.addEventListener('message', onMessage, false);
    return () => {
      window.removeEventListener('message', onMessage);
    }; // will happen on unmount
  }, []);

  useEffect(() => {
    const pledgeElem = document.getElementById('wf-plg-donate');
    const target = document.getElementById('pledge-module');
    setPlgElem(pledgeElem);
    setTargetElem(target);
  }, []);

  return targetElem
    ? ReactDOM.createPortal(<div ref={(ref) => ref.appendChild(plgElem)} />, targetElem)
    : null;
};

const root = createRoot(document.getElementById('pledge-portal'));
root.render(<WebflowWithPledge />);
